<template>
  <footer class="footer">
    <v-container>
      <div :class="isShowFiltre ? 'footer-items' : 'footer-rams'">
        <div class="first">
          <div class="left">
            <div v-if="isShowFiltre" class="logo">
              <img loading="lazy" src="~/assets/images/div-beyaz-logo.svg" alt="divissa" />
            </div>

          </div>
          <v-row v-if="!isShowFiltre" class="d-flex justify-center align-center py-6">
            <v-col cols="auto"> <img loading="lazy" src="~/assets/images/rams/ramsLogo.svg" alt="divissa" /></v-col>
            <v-col cols="auto"> <img loading="lazy" src="~/assets/images/rams/&.svg" alt="divissa" /></v-col>
            <v-col cols="auto"> <img loading="lazy" src="~/assets/images/rams/divissaLogo.svg" alt="divissa" /></v-col>
          </v-row>
          <div v-if="isShowFiltre" class="right">
            <div class="socials">
              <ul>
                <li>
                  <a href="https://www.linkedin.com/company/divissa/" target="_blank">
                    <v-img loading="lazy" src="~/assets/images/link.svg" class="socialMedya" alt="linkedin"></v-img>
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/divissa.tr/" target="_blank">
                    <v-img loading="lazy" src="~/assets/images/inst.svg" class="socialMedya" alt="instagram"></v-img>
                  </a>
                </li>
                <li>
                  <a href="https://x.com/divissatech" target="_blank">
                    <v-img loading="lazy" src="~/assets/images/x.svg" class="socialMedya" alt="x"></v-img>
                  </a>
                </li>
                <li>
                  <a href="https://www.youtube.com/@divissa" target="_blank">
                    <v-img loading="lazy" src="~/assets/images/yt.svg" class="socialMedya" alt="youtube"></v-img>
                  </a>
                </li>
                <li>
                  <a href="https://www.facebook.com/profile.php?id=61564288706937" target="_blank">
                    <v-img loading="lazy" src="~/assets/images/face.svg" class="socialMedya" alt="facebook"></v-img>
                  </a>
                </li>
              </ul>
            </div>
            <div v-if="innerWidth > 425" class="download-mobile-links">
              <ul>
                <li>
                  <nuxt-link to="https://play.google.com/store/apps/details?id=com.intimeinfo.divissa"
                    class="store-link" target="_blank">
                    <img loading="lazy" cover :src="googleplay" alt="Google Play" />
                  </nuxt-link>
                </li>
                <li>
                  <nuxt-link to="https://apps.apple.com/tr/app/divissa/id6470978019" class="store-link" target="_blank">
                    <img loading="lazy" cover :src="appstore" alt="Apple App Store" />
                  </nuxt-link>
                </li>
                <li>
                  <nuxt-link to="https://appgallery.cloud.huawei.com/ag/n/app/C111965315" class="store-link"
                    target="_blank">
                    <img loading="lazy" cover :src="appgallery" alt="Huawei AppGallery" />
                  </nuxt-link>
                </li>
              </ul>
            </div>
            <v-row v-else class="d-flex justify-center">
              <v-col cols="6" class="d-flex justify-center">
                <nuxt-link to="https://play.google.com/store/apps/details?id=com.intimeinfo.divissa" class="store-link"
                  target="_blank">
                  <img loading="lazy" cover :src="googleplay" alt="Google Play" width="100%" height="40px" />
                </nuxt-link>
              </v-col>
              <v-col cols="6" class="d-flex justify-center">
                <nuxt-link to="https://apps.apple.com/tr/app/divissa/id6470978019" class="store-link" target="_blank">
                  <img loading="lazy" cover :src="appstore" alt="Apple App Store" width="100%" height="40px" />
                </nuxt-link>
              </v-col>
              <v-col cols="6" class="d-flex justify-center">
                <nuxt-link to="https://appgallery.cloud.huawei.com/ag/n/app/C111965315" class="store-link"
                  target="_blank">
                  <img loading="lazy" cover :src="appgallery" alt="Huawei AppGallery" width="100%" height="40px" />
                </nuxt-link>
              </v-col>
            </v-row>
          </div>
        </div>
        <v-divider v-if="!isShowFiltre" :thickness="2" color="blue"></v-divider>
        <div class="second" :class="isShowFiltre ? '' : 'd-flex justify-center py-4'">
          <div class="routes">
            <ul>
              <li v-for="(route, index) in routes" :key="index">
                <nuxt-link :to="route.link">{{ route.name }}</nuxt-link>
              </li>
            </ul>
          </div>
          <div v-if="isShowFiltre" id="ETBIS" class="etbis-sponsor">
            <div id="1620662035627500">
              <a href="https://etbis.eticaret.gov.tr/sitedogrulama/1620662035627500" target="_blank"><img loading="lazy"
                  alt="etbis"  width="100px" height="100%" src="~/assets/images/etbis.avif" /></a>
            </div>

          </div>
        </div>

        <v-divider v-if="isShowFiltre" :thickness="2"></v-divider>
        <v-col class="pa-0 ma-0" v-resize="onResize"></v-col>
        <div v-if="isShowFiltre" class="sozlesmeler">
          <ul>
            <li v-for="(item, index) in (contactList as ContractInfoResponse[])" :key="'category-' + index">
              <span @click="gotoCategoryName(item?.contractSeoUrl ?? '')" class="pointer">
                {{ item?.contractName }}
              </span>
            </li>
          </ul>
        </div>

        <div v-if="isShowFiltre" class="bottom">
          <!-- Sponsorluk Bölümü -->

          <div class="text" data-nosnippet>
            Divissa olarak, kişisel verilerinizin güvenliğine büyük önem veriyoruz. Yatırımlarınız sırasında
            paylaştığınız tüm bilgiler, Kişisel Verilerin Korunması Kanunu (KVKK) kapsamında güvence altındadır.
            Verileriniz, yalnızca belirtilen amaçlar doğrultusunda işlenmekte ve üçüncü kişilerle paylaşılmadan önce
            açık rızanız alınmaktadır. Gizlilik politikamız ve veri işleme süreçlerimiz hakkında daha fazla bilgi almak
            için lütfen KVKK Aydınlatma Metni ve Gizlilik Politikası sayfalarımızı ziyaret edin. Verilerinizin güvenliği
            bizim önceliğimizdir.
          </div>
        </div>
      </div>
    </v-container>
   
  </footer>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useRouter } from "vue-router";
import { mapActions, mapState } from "~/node_modules/pinia/dist/pinia";
import { useMyCommonStore } from "~/stores/common";
import googleplay from "~/assets/images/google-play-indir.webp";
import appstore from "~/assets/images/apple-store-indir.webp";
import appgallery from "~/assets/images/appGallery.avif";
import type { CategoryDto } from "~/models/common/CategoryDto";
import type { ContractInfoResponse } from "~/models/common/ContractInfoResponse";
import { footerRoutes } from "~/utils/routes";

export default defineComponent({
  props: {
    isShowFiltre: {
      type: Boolean,
      required: false,
      default:true
    },
  
  },
  data() {
    return {
      googleplay: googleplay,
      appstore: appstore,
      appgallery: appgallery,
      routes: footerRoutes,
      newsletterEmail: "",
      displayedCategoryNames: new Set(),
      router: useRouter(),
      contractList: [],
      innerWidth: 961,
      lastVisibleState: null as boolean | null,
    };
  },
  async mounted() {
    const store = useMyCommonStore();
    await store.getAllContact();
    this.innerWidth = window.innerWidth;
  },
  computed: {
    ...mapState(useMyCommonStore, [
      "contractInfoResponse",
      "contractsByCategoryResponse",
    ]),
    contactList() {
      if (typeof window !== "undefined") {
        return this.contractInfoResponse;
      }
    },
    contractsByCategoryRes() {
      if (typeof window !== "undefined") {
        return this.contractsByCategoryResponse;
      }
    },
  },
  methods: {
    ...mapActions(useMyCommonStore, [
      "getAllContact",
      "getContractsByCategory",
      "setSelectedParentTitle",
    ]),
    ...mapActions(useMyCookieStore, [
      "updateInnerWidth"
    ]),
    async validate() {
      const formElement = this.$refs.form as HTMLFormElement;
      const { valid } = await formElement.validate();

      if (valid) this.registerNewsletter();
    },
    registerNewsletter() {
      if (
        !this.newsletterEmail ||
        !this.newsletterEmail.includes("@") ||
        !this.newsletterEmail.includes(".") ||
        this.newsletterEmail == ""
      ) {
        {
          toast.error("Lütfen geçerli bir e-posta adresi giriniz.");
        }
      } else {
        {
          toast.success(
            "E-posta adresiniz bültenimize başarıyla kaydedildi. (geliştirme aşamasında)"
          );
          this.newsletterEmail = "";
        }
      }
    },
    gotoCategoryName(categoryName: string) {
      this.getContractsByCategory().then(() => {
        for (const category of this
          .contractsByCategoryRes as Array<CategoryDto>) {
          // Her kategori içerisindeki contracts dizisini dolaş
          if (category.contracts) {
            for (const contract of category.contracts) {
              if (contract.seoUrl === categoryName) {
                const categoryUrl = category.seoUrl;
                const contrantName = contract.seoUrl;
                if (categoryName && categoryName !== "kvkk") {
                  this.router.push({
                    path: `/${categoryUrl}/${contrantName}`,
                    replace: true,
                  });
                } else {
                  this.router.push({ path: `/${categoryUrl}`, replace: true });
                }
              }
            }
          }
        }
      });
    },
    async gotoContractSeo(
      categoryUrl: string,
      contrantName: string,
      categoryName: string
    ) {
      const store = useMyCommonStore();
      await store.getContractsByCategory();
      store.setSelectedParentTitle(categoryName);
      if (categoryName && categoryName !== "kvkk") {
        this.router.push({
          path: `/${categoryUrl}/${contrantName}`,
          replace: true,
        });
      } else {
        this.router.push({ path: `/${categoryUrl}`, replace: true });
      }
    },
    onResize() {
      this.innerWidth = window.innerWidth;
      this.updateInnerWidth(window.innerWidth);
    },
  },
});
</script>
<style scoped lang="less">
.pointer {
  cursor: pointer;
}

.socialMedya {
  width: 50px;
  height: 30px;
}

.second {
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 10;

  @media screen and (max-width: 768px) {
      flex-direction: column;
      gap: 24px;
      align-items: center;
  }

  .routes {
      ul {
          display: flex;
          gap: 60px;
          flex-wrap: wrap;

          @media screen and (max-width: 768px) {
              gap: 24px;
              justify-content: center;
          }

          li {
              a {
                  color: var(--color-background);
                  font-size: 16px;
                  font-weight: 500;
              }
          }
      }
  }
}

.footer-rams {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 20px 0;
  position: relative;
}

.bottom {
 

  .text {
    color: var(--color-background);
    font-size: 14px;
    line-height: 1.5;
    text-align: left;
  }
}

.etbis-sponsor {
  display: flex;
  align-items: center;
  gap: 24px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
 
}

</style>
